var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 37.5H41.25V54.375H45V35.625C45 34.5887 44.1613 33.75 43.125 33.75H31.875C30.8387 33.75 30 34.5887 30 35.625V54.375H33.75V37.5Z",
    fill: "#2AA7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.625 18.75H41.25V22.5H48.75V52.5H11.25V22.5H18.75V18.75H9.375C8.33869 18.75 7.5 19.5887 7.5 20.625V54.375C7.5 55.4113 8.33869 56.25 9.375 56.25H50.625C51.6613 56.25 52.5 55.4113 52.5 54.375V20.625C52.5 19.5887 51.6613 18.75 50.625 18.75Z",
    fill: "#2AA7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.75H7.5V15H18.75V11.25H5.625C4.58869 11.25 3.75 12.0887 3.75 13.125V20.625C3.75 21.6613 4.58869 22.5 5.625 22.5H18.75V18.75Z",
    fill: "#2AA7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.375 11.25H41.25V15H52.5V18.75H41.25V22.5H54.375C55.4113 22.5 56.25 21.6613 56.25 20.625V13.125C56.25 12.0887 55.4113 11.25 54.375 11.25Z",
    fill: "#2AA7FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 30H18.75C17.7137 30 16.875 29.1613 16.875 28.125V5.625C16.875 4.58869 17.7137 3.75 18.75 3.75H41.25C42.2863 3.75 43.125 4.58869 43.125 5.625V28.125C43.125 29.1613 42.2863 30 41.25 30ZM20.625 26.25H39.375V7.5H20.625V26.25Z",
    fill: "#2AA7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.75 15H31.875V13.125C31.875 12.0887 31.0363 11.25 30 11.25C28.9637 11.25 28.125 12.0887 28.125 13.125V15H26.25C25.2137 15 24.375 15.8387 24.375 16.875C24.375 17.9113 25.2137 18.75 26.25 18.75H28.125V20.625C28.125 21.6613 28.9637 22.5 30 22.5C31.0363 22.5 31.875 21.6613 31.875 20.625V18.75H33.75C34.7863 18.75 35.625 17.9113 35.625 16.875C35.625 15.8387 34.7863 15 33.75 15Z",
    fill: "#2AA7FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 45H16.875C15.8387 45 15 44.1613 15 43.125V39.375C15 36.2732 17.5232 33.75 20.625 33.75C23.7268 33.75 26.25 36.2732 26.25 39.375V43.125C26.25 44.1613 25.4113 45 24.375 45ZM18.75 41.25H22.5V39.375C22.5 38.3404 21.6596 37.5 20.625 37.5C19.5904 37.5 18.75 38.3404 18.75 39.375V41.25Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragStore);
export default __webpack_public_path__ + "static/media/drag_store.5f51558eb75927618d58166c1724440b.svg";
export { ForwardRef as ReactComponent };